// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/config.css'
import './assets/css/main.css'
import VCalendar from 'v-calendar'
import VueTablerIcons from 'vue-tabler-icons'
import i18n from './i18n'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import PhosphorIcons from 'phosphor-icons'
import pdf from 'vue-pdf'

import * as Sentry from '@sentry/vue'
import {Integrations} from '@sentry/tracing'

import setupInterceptors from './services/setupInterceptors'

Vue.config.productionTip = false

// Make BootstrapVue available throughout project
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueTablerIcons)
Vue.use(PhosphorIcons)
const moment = require('moment')
require('moment/locale/fr')
Vue.use(require('vue-moment'), {
  moment
})
Vue.use(pdf)
Vue.component('pdf', pdf);

// Lib utlisée pour les icones
// Version 1.* (compatible avec Vue 2)
// Icones : https://tabler-icons.io/
// Documentation lib : https://github.com/alex-oleshkevich/vue-tabler-icons

setupInterceptors(store, router)

VuePhoneNumberInput.props.translations.default = function () {
  return {
    countrySelectorLabel: 'Code pays',
    countrySelectorError: 'Choisir un pays',
    phoneNumberLabel: 'Numéro de téléphone',
    example: 'Exemple :'
  }
}
VuePhoneNumberInput.props.color.default = '#80BDFF'
VuePhoneNumberInput.props.validColor.default = '#99CC55'
VuePhoneNumberInput.props.errorColor.default = '#FF6464'
VuePhoneNumberInput.props.defaultCountryCode.default = 'FR'
VuePhoneNumberInput.props.onlyCountries.default = function () {
  return [
    'AL', // Albanie
    'DE', // Allemagne
    'AD', // Andorre
    'AT', // Autriche
    'BE', // Belgique
    'BY', // Biélorussie
    'BA', // Bosnie-Herzégovine
    'BG', // Bulgarie
    'CY', // Chypre
    'HR', // Croatie
    'DK', // Danemark
    'ES', // Espagne
    'EE', // Estonie
    'FI', // Finlande
    'FR', // France
    'GR', // Grèce
    'HU', // Hongrie
    'IE', // Irlande
    'IS', // Islande
    'IT', // Italie
    'XK', // Kosovo
    'LV', // Lettonie
    'LI', // Liechtenstein
    'LT', // Lituanie
    'LU', // Luxembourg
    'MK', // Macédoine du Nord
    'MT', // Malte
    'MD', // Moldavie
    'MC', // Monaco
    'ME', // Monténégro
    'NO', // Norvège
    'NL', // Pays-Bas
    'PL', // Pologne
    'PT', // Portugal
    'CZ', // République tchèque
    'RO', // Roumanie
    'GB', // Royaume-Uni
    'RU', // Russie
    'SM', // Saint-Marin
    'RS', // Serbie
    'SK', // Slovaquie
    'SI', // Slovénie
    'SE', // Suède
    'CH', // Suisse
    'UA', // Ukraine
    'VA'  // Vatican
  ]
}
Vue.component('vue-phone-number-input', VuePhoneNumberInput)
Vue.use(VCalendar, {
  componentPrefix: 'vc' // Use <vc-calendar /> instead of <v-calendar />
})
// Sentry
/* Sentry.init({
  Vue,
  dsn: 'https://c50ce19866024e6999afe1c50a268d78@o493491.ingest.sentry.io/6199512',
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ['http://preprod-omitzuka.bleu122.com/', /^\//]
    })
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0
}) */
export const bus = new Vue()
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  i18n,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js